import { cva } from 'class-variance-authority'

import { ControlStatus } from '@/gen/controls/v1/control_status_pb'

export const controlStatusVariant = cva(
  'text-md flex w-fit items-center gap-1 whitespace-nowrap border-none px-1.5 py-1 font-medium rounded',
  {
    variants: {
      variant: {
        outline: 'p-0',
        default: '',
      },
      status: {
        [ControlStatus.GAP]:
          'bg-main-background-subtle-semantic-danger text-main-foreground-danger',
        [ControlStatus.VALIDATED]:
          'bg-main-background-subtle-semantic-success text-main-foreground-success',
        [ControlStatus.NO_EVIDENCE]:
          'bg-main-background-subtle-semantic-warning text-main-foreground-warning',
        [ControlStatus.NOT_EVALUATED]: 'bg-main-background-muted text-main-foreground-secondary',
        [ControlStatus.NOT_APPLICABLE]: 'bg-main-background-muted text-main-foreground-secondary',
        [ControlStatus.ATTESTED]:
          'bg-main-background-subtle-semantic-accent text-main-foreground-accent',
        [ControlStatus.UNSPECIFIED]: 'bg-main-background-muted text-main-foreground-disabled',
      },
    },
    compoundVariants: [
      {
        status: ControlStatus.GAP,
        variant: 'outline',
        className: 'bg-transparent text-main-foreground-danger',
      },
      {
        status: ControlStatus.VALIDATED,
        variant: 'outline',
        className: 'bg-transparent text-main-foreground-success',
      },
      {
        status: ControlStatus.NO_EVIDENCE,
        variant: 'outline',
        className: 'bg-transparent text-main-foreground-warning',
      },
      {
        status: ControlStatus.NOT_EVALUATED,
        variant: 'outline',
        className: 'bg-transparent text-main-foreground-secondary',
      },
      {
        status: ControlStatus.NOT_APPLICABLE,
        variant: 'outline',
        className: 'bg-transparent text-main-foreground-secondary',
      },
      {
        status: ControlStatus.ATTESTED,
        variant: 'outline',
        className: 'bg-transparent text-main-foreground-accent',
      },
      {
        status: ControlStatus.UNSPECIFIED,
        variant: 'outline',
        className: 'bg-transparent',
      },
    ],
  },
)
